var viewer_rtlignore_default = {
  "gallery_container": "fwTFF",
  "imageTitleContainer": "kB8w2",
  "clickableItem": "K5mpA",
  "prerender": "ELanA",
  "expandContainer": "UJ1rw",
  "expandIcon": "EqC21",
  "itemOverlay": "bzNsU",
  "imageTitle": "Aez89",
  "pointer": "AK2tJ",
  "fadeIn": "z0o3X",
  "changing_background": "uJDgG"
};
export {
  viewer_rtlignore_default as default
};
//# sourceMappingURL=viewer.rtlignore-scss.js.map
